import { memo } from 'react'

type IconProps = {
  className?: string
  stroke?: string
  viewBox?: string
}

const DocumentTextIcon = ({
  className = 'w-6 h-6 stroke-gray-800',
  stroke = 'none',
  viewBox = '0 0 24 24',
}: IconProps) => (
  <svg viewBox={viewBox} stroke={stroke} fill='none' className={className}>
    <path
      d='M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default memo(DocumentTextIcon)
